import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

import { getHolidaysSpecial } from 'RestAPIs/admin';

import { showSnackbar } from 'components/shared';

export const useGetHolidaysSpecialRowData = () => {
  const { t } = useTranslation('common');

  return useQuery({
    queryKey: ['holidays-special', 'details'],
    initialData: undefined,
    queryFn: async () => {
      return await getHolidaysSpecial().then((response) => response.data);
    },
    onError: () => {
      showSnackbar({
        severity: 'error',
        message: t('errorDuringFetching')
      });
    }
  });
};
export default useGetHolidaysSpecialRowData;
